// web/src/screens/Login.tsx (/login) — MSAL redirect entry (D16 §4). Honors ?next=; skips if already signed in.
// In mock mode auth is bypassed (isSignedIn() === true), so this routes straight through — see-it-first.
import { useEffect } from 'react';
import { isSignedIn, login } from '../lib/auth';
import { Icon } from '../components/Icon';
import { BRAND } from '../lib/brand';

export function Login() {
  useEffect(() => {
    const next = new URLSearchParams(window.location.search).get('next') || '/';
    if (isSignedIn()) { window.location.replace(next); return; }
    sessionStorage.setItem('next', next);
    void login(); // MSAL loginRedirect → Entra
  }, []);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-bg px-6 text-center">
      <span className="flex size-12 items-center justify-center rounded-lg bg-run text-runink"><Icon name="rocket" size={24} /></span>
      <h1 className="font-head text-lg text-ink">{BRAND.name}</h1>
      <div className="flex items-center gap-2 text-sm text-muted">
        <Icon name="loader" size={16} className="animate-spin" />Taking you to sign in…
      </div>
    </div>
  );
}
